import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

export default function UsernameGreeting() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  return (
    <Typography
      component="h1"
      variant="h6"
      noWrap
      style={{ color: "white" }}
    >
      {t("shared.greeting", { name: user?.firstName ?? user?.userName })}
    </Typography>
  );
}
